import { Mail, Filter } from "lucide-react";
import { PaginatedEmailList } from "../components/PaginatedEmailList";

export function AdminEmailsList() {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-silica font-display flex items-center gap-2">
          <Mail className="h-6 w-6" />
          All Emails
        </h1>
        <p className="text-chromium-mist mt-1">
          View all emails sent from the system, including authentication, invitations, and custom emails.
        </p>
      </div>

      <PaginatedEmailList />
    </div>
  );
}
